/**
 * Activity Screen Styles
 * 
 * Extracted for Cursor Rules compliance (300 line limit).
 */

import { StyleSheet } from 'react-native';
import { color, space, text, radius, touch } from '../../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  container: { flex: 1 },
  scroll: { flex: 1 },
  scrollContent: { padding: space.md, flexGrow: 1 },
  center: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: space.lg },

  // Tab bar
  tabBar: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: color.divider },
  tab: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: space.xs, paddingVertical: space.md },
  tabActive: { borderBottomWidth: 2, borderBottomColor: color.primary },
  tabText: { fontSize: text.body.fontSize, color: color.textMuted },
  tabTextActive: { color: color.primary, fontWeight: text.bodyMedium.fontWeight },

  // Error state
  errorText: { fontSize: text.body.fontSize, color: color.error, marginTop: space.md, textAlign: 'center' },
  retryButton: { marginTop: space.md, paddingHorizontal: space.lg, paddingVertical: space.sm, backgroundColor: color.primary, borderRadius: radius.md },
  retryText: { fontSize: text.body.fontSize, color: color.surface, fontWeight: text.bodyMedium.fontWeight },

  // Empty state
  emptyState: { flex: 1, alignItems: 'center', justifyContent: 'center', paddingVertical: space.xxl },
  emptyTitle: { fontSize: text.cardTitle.fontSize, fontWeight: text.cardTitle.fontWeight, color: color.textPrimary, marginTop: space.md },
  emptySubtitle: { fontSize: text.body.fontSize, color: color.textMuted, marginTop: space.xs, textAlign: 'center' },

  // Comment card
  commentCard: { backgroundColor: color.surface, borderRadius: radius.md, padding: space.md, marginBottom: space.sm, borderWidth: 1, borderColor: color.divider },
  commentHeader: { flexDirection: 'row', alignItems: 'center', marginBottom: space.sm },
  avatar: { width: 32, height: 32, borderRadius: 16, backgroundColor: color.primary, alignItems: 'center', justifyContent: 'center' },
  avatarText: { color: color.surface, fontSize: text.caption.fontSize, fontWeight: text.bodyMedium.fontWeight },
  commentMeta: { marginLeft: space.sm },
  commentAuthor: { fontSize: text.body.fontSize, fontWeight: text.bodyMedium.fontWeight, color: color.textPrimary },
  commentTime: { fontSize: text.caption.fontSize, color: color.textMuted },
  commentContent: { fontSize: text.body.fontSize, color: color.textPrimary, lineHeight: 20 },

  // Input bar
  inputBar: { flexDirection: 'row', alignItems: 'flex-end', padding: space.sm, borderTopWidth: 1, borderTopColor: color.divider, backgroundColor: color.background },
  input: { flex: 1, backgroundColor: color.backgroundSecondary, borderRadius: radius.md, paddingHorizontal: space.md, paddingVertical: space.sm, fontSize: text.body.fontSize, color: color.textPrimary, maxHeight: 100 },
  sendButton: { width: touch.minimum, height: touch.minimum, backgroundColor: color.primary, borderRadius: radius.md, alignItems: 'center', justifyContent: 'center', marginLeft: space.sm },
  sendButtonDisabled: { backgroundColor: color.textMuted },

  // History/Activity items
  historyItem: { flexDirection: 'row', paddingVertical: space.sm, borderBottomWidth: 1, borderBottomColor: color.divider },
  historyIconContainer: { width: 32, height: 32, borderRadius: 16, backgroundColor: color.backgroundSecondary, alignItems: 'center', justifyContent: 'center', marginRight: space.sm },
  historyContent: { flex: 1 },
  historyAction: { fontSize: text.body.fontSize, color: color.textPrimary },
  historyActionBold: { fontWeight: text.bodyMedium.fontWeight },
  historyTime: { fontSize: text.caption.fontSize, color: color.textMuted, marginTop: 2 },
  historyDetails: { marginTop: space.xs, backgroundColor: color.backgroundSecondary, padding: space.sm, borderRadius: radius.sm },
  historyDetailText: { fontSize: text.caption.fontSize, color: color.textSecondary },
});

